import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { periodesApi } from '../api/periodes.api'
import type { CreatePeriodeRequest, UpdatePeriodeRequest } from '@/shared/types/admin'

const PERIODES_KEY = ['periodes']

export function usePeriodes() {
  return useQuery({
    queryKey: PERIODES_KEY,
    queryFn: periodesApi.getAll,
    select: (data) => [...data].sort((a, b) => a.titre.localeCompare(b.titre)),
  })
}

export function usePeriode(id: number | undefined) {
  return useQuery({
    queryKey: [...PERIODES_KEY, id],
    queryFn: () => periodesApi.getById(id!),
    enabled: !!id,
  })
}

export function useCreatePeriode() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreatePeriodeRequest) => periodesApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PERIODES_KEY }),
  })
}

export function useUpdatePeriode() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdatePeriodeRequest }) =>
      periodesApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PERIODES_KEY }),
  })
}

export function useDeletePeriode() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => periodesApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PERIODES_KEY }),
  })
}
